'use es6';

import { __ANY_CTA } from 'customer-data-filters/converters/listSegClassic/ListSegConstants';
import { deref, unwatch, watch } from 'atom';
import { isResolved } from 'reference-resolvers/utils';
import FilterOperatorType from 'customer-data-filters/components/propTypes/FilterOperatorType';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import get from 'transmute/get';
import indexBy from 'transmute/indexBy';
import { jsx as _jsx } from "react/jsx-runtime";
export default class DisplayValueCta extends PureComponent {
  constructor() {
    super();
    this.handleReferenceChange = reference => {
      const {
        value
      } = this.props;
      if (isResolved(reference)) {
        const ctas = indexBy(get('guid'), reference.referencedObject.get('ctaInfo'));
        const label = ctas.getIn([value, 'label']) ? ctas.getIn([value, 'label']) : I18n.text('customerDataFilters.FilterEditor.specialOptionValues.variationCta.display', {
          variantLabel: ctas.getIn([value, 'variantLabel'])
        });
        const isDefault = ctas.getIn([value, 'isDefault']);
        this.setState({
          reference: isDefault ? I18n.text('customerDataFilters.FilterEditor.specialOptionValues.defaultCta.display') : label
        });
      }
    };
    this.state = {
      reference: null
    };
    this.referenceAtom = null;
  }
  componentDidMount() {
    this.getReference();
  }
  componentDidUpdate(prevProps) {
    const {
      operator
    } = this.props;
    const prevOperator = prevProps.operator;
    if (operator.field.name !== prevOperator.field.name || operator.value !== prevOperator.value) {
      this.getReference();
    }
  }
  componentWillUnmount() {
    if (this.referenceAtom) {
      unwatch(this.referenceAtom, this.handleReferenceChange);
    }
  }
  getReference() {
    const {
      getFamilyValueResolver,
      operator,
      value
    } = this.props;
    const resolver = getFamilyValueResolver(operator);
    if (value === __ANY_CTA) {
      this.setState({
        reference: value
      });
    } else if (resolver && resolver.byId && operator.field.name !== 'undefined') {
      if (this.referenceAtom) {
        unwatch(this.referenceAtom, this.handleReferenceChange);
      }
      this.referenceAtom = resolver.byId(operator.field.name);
      watch(this.referenceAtom, this.handleReferenceChange);
      this.handleReferenceChange(deref(this.referenceAtom));
    }
  }
  getValueName() {
    const {
      reference
    } = this.state;
    if (reference === __ANY_CTA) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFilters.FilterEditor.specialOptionValues.anyCta.display"
      });
    }
    return reference;
  }
  render() {
    return /*#__PURE__*/_jsx("span", {
      children: this.getValueName()
    });
  }
}
DisplayValueCta.propTypes = {
  getFamilyValueResolver: PropTypes.func.isRequired,
  operator: FilterOperatorType.isRequired,
  value: PropTypes.string.isRequired
};